
<template>
  <el-card shadow="never">
    <div v-if="showTitle" slot="header">
      <span>订单详情</span>
    </div>
    <el-form-item label="订单号：" prop="OrderID">
      <span>{{ order.OrderID}}</span>
    </el-form-item>
    <el-form-item label="上门地址：" prop="UserMobile">
      <div v-if="order.UserAddress && order.UserAddress.Key">
        <span>{{ order.UserAddress.receiver_name }}</span>
        <span>{{
          order.UserAddress.receiver_mobile
            ? order.UserAddress.receiver_mobile
            : order.UserAddress.receiver_phone
        }}</span>
        <br />
        <span>{{ order.UserAddress.receiver_address }}</span>
      </div>
    </el-form-item>
    <el-form-item label="预定商品：" prop="Comment">
      <span>{{ order.Quantity }}*{{ order.ProductName }}</span>
    </el-form-item>
    <el-form-item label="订单金额：" prop="TotalAmount">
      <el-tag type="info" style="font-weight:bolder;color:black;">总额 {{ order.TotalAmount }}</el-tag>
      <el-tag type="info" v-if="order.PromoAmount" style="color:#4caf50;font-weight:bolder">优惠 {{ order.PromoAmount }}</el-tag>
      <el-tag type="info" v-if="order.AddAmount" style="color:#FF0000;font-weight:bolder">加费 {{ order.AddAmount }}</el-tag>
    </el-form-item>
    <el-form-item label="预订时段：" prop="Comment">
      <el-tag type="info" style="font-weight:bolder;color:chocolate;">{{
        format.dateTimeFormat(order.BeginTime)
      }}</el-tag>
      <!--<el-tag type="info" v-if="order.Duration">{{ order.Duration }}</el-tag>
      <el-tag type="info" style="font-weight:bolder;color:chocolate;">{{ format.dateTimeFormat(order.EndTime) }}</el-tag> -->
    </el-form-item>
    <el-form-item
      v-if="order.Worker && order.Worker.Key"
      label="派单信息："
      prop="Workder"
    >
      <div>
        <i style="font-size: 18px; color: chocolate" class="el-icon-time" />
        <span style="font-size: 12px; font-weight: bold">
          {{ format.dateTimeFormat(order.DispatchDate) }}</span
        ><br />
        <i
          style="cursor: pointer; font-size: 18px; color: chocolate"
          class="el-icon-s-custom"
        />
        <span style="font-size: 12px; font-weight: bold" type="success"
          >{{ order.Worker.Name }}/{{ order.Worker.Mobile }}</span
        ><br />
        <i
          style="cursor: pointer; font-size: 18px; color: chocolate"
          class="el-icon-money"
        /><span style="font-size: 14px; font-weight: bold"
          >{{ order.WorkerCommission }}+{{ order.WorkerBonos }}</span
        >
      </div>
    </el-form-item>
    <el-timeline v-if="showTimeLine && order.Process">
      <el-timeline-item
        v-for="(activity, index) in order.Process.Items"
        :key="index"
        :timestamp="format.dateTimeFormat(activity.InsertTime)"
      >
        <el-tag
          ><span>{{ format.orderStatusFormat(activity.Status) }}</span></el-tag
        >
        {{ activity.Desc }}
      </el-timeline-item>
    </el-timeline>
  </el-card>
</template>
      <script>
export default {
  components: {},
  props: {
    showTimeLine: {
      default: true,
    },
    showTitle:true,
    order: {
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>
<style lang='scss'  scoped>
</style>